var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogbadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 74,
    viewBox: "0 0 250 74",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Badges",
    clipPath: "url(#clip0_1_1279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.737 73.7607H9.26267C4.15762 73.7607 0 69.6037 0 64.5407V9.22009C0 4.1387 4.15762 0 9.26267 0H240.737C245.838 0 250 4.1387 250 9.22009V64.5407C250 69.6037 245.838 73.7607 240.737 73.7607Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.737 1.47613C245.019 1.47613 248.524 4.95724 248.524 9.22009V64.5407C248.524 68.8035 245.042 72.2846 240.737 72.2846H9.26267C4.98087 72.2846 1.47632 68.8035 1.47632 64.5407V9.22009C1.47632 4.95724 4.95787 1.47613 9.26267 1.47613H240.737ZM240.737 0H9.26267C4.15762 0 0 4.15709 0 9.22009V64.5407C0 69.6221 4.15762 73.7607 9.26267 73.7607H240.737C245.838 73.7607 250 69.6221 250 64.5407V9.22009C250 4.15709 245.838 0 240.737 0Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M131.701 24.3998C130.031 24.3998 128.624 23.8158 127.511 22.6661C126.407 21.5487 125.791 20.0082 125.819 18.4355C125.819 16.757 126.389 15.3361 127.511 14.2094C128.619 13.0598 130.027 12.4758 131.696 12.4758C133.347 12.4758 134.755 13.0598 135.886 14.2094C137.008 15.3728 137.578 16.7938 137.578 18.4355C137.56 20.1186 136.99 21.5395 135.886 22.6615C134.778 23.8204 133.37 24.3998 131.701 24.3998ZM82.0258 24.3998C80.3931 24.3998 78.9766 23.825 77.8176 22.6891C76.6678 21.5579 76.0837 20.1277 76.0837 18.4401C76.0837 16.7524 76.6678 15.3223 77.8176 14.191C78.9536 13.0552 80.3701 12.4804 82.0258 12.4804C82.8352 12.4804 83.6217 12.6413 84.3759 12.9678C85.1164 13.2851 85.7189 13.7174 86.165 14.2462L86.2754 14.3796L85.029 15.6028L84.9002 15.451C84.1966 14.6141 83.2538 14.2048 82.0074 14.2048C80.8944 14.2048 79.924 14.6003 79.1238 15.382C78.3189 16.1684 77.9096 17.1985 77.9096 18.4447C77.9096 19.6909 78.3189 20.721 79.1238 21.5073C79.924 22.2891 80.8944 22.6845 82.0074 22.6845C83.194 22.6845 84.192 22.2891 84.9692 21.5073C85.4291 21.0475 85.7143 20.4037 85.8155 19.5897H81.8188V17.8699H87.5309L87.5539 18.0262C87.5953 18.3159 87.6367 18.6148 87.6367 18.8907C87.6367 20.4772 87.1584 21.7602 86.211 22.7075C85.1348 23.8296 83.7275 24.3998 82.0258 24.3998ZM148.074 24.1561H146.312L140.917 15.5246L140.963 17.0789V24.1515H139.202V12.7241H141.212L141.267 12.8115L146.34 20.9417L146.294 19.392V12.7241H148.074V24.1561ZM118.465 24.1561H116.68V14.4439H113.585V12.7241H121.555V14.4439H118.46V24.1561H118.465ZM112.132 24.1561H110.352V12.7241H112.132V24.1561ZM102.129 24.1561H100.349V14.4439H97.2535V12.7241H105.224V14.4439H102.129V24.1561ZM96.1267 24.1377H89.3016V12.7241H96.1267V14.4439H91.086V17.5802H95.6346V19.2816H91.086V22.4178H96.1267V24.1377ZM128.817 21.4843C129.613 22.2799 130.579 22.6799 131.701 22.6799C132.855 22.6799 133.798 22.2891 134.584 21.4843C135.366 20.7026 135.762 19.6771 135.762 18.4401C135.762 17.2031 135.366 16.173 134.589 15.3958C133.793 14.6003 132.823 14.2002 131.705 14.2002C130.551 14.2002 129.608 14.5911 128.826 15.3958C128.045 16.1776 127.649 17.2031 127.649 18.4401C127.649 19.6771 128.04 20.7072 128.817 21.4843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.653 40.1178C121.307 40.1178 117.784 43.4149 117.784 47.9629C117.784 52.4695 121.33 55.808 125.653 55.808C129.999 55.808 133.522 52.4879 133.522 47.9629C133.522 43.4149 129.999 40.1178 125.653 40.1178ZM125.653 52.6994C123.275 52.6994 121.229 50.7312 121.229 47.9445C121.229 45.1164 123.28 43.1896 125.653 43.1896C128.031 43.1896 130.077 45.1164 130.077 47.9445C130.082 50.7496 128.031 52.6994 125.653 52.6994ZM108.484 40.1178C104.138 40.1178 100.615 43.4149 100.615 47.9629C100.615 52.4695 104.161 55.808 108.484 55.808C112.831 55.808 116.354 52.4879 116.354 47.9629C116.354 43.4149 112.826 40.1178 108.484 40.1178ZM108.484 52.6994C106.107 52.6994 104.06 50.7312 104.06 47.9445C104.06 45.1164 106.111 43.1896 108.484 43.1896C110.862 43.1896 112.909 45.1164 112.909 47.9445C112.909 50.7496 110.862 52.6994 108.484 52.6994ZM88.055 42.5136V45.8338H96.0253C95.7816 47.6962 95.1653 49.0711 94.2225 50.0138C93.0543 51.1819 91.2514 52.4511 88.0734 52.4511C83.1753 52.4511 79.3442 48.4963 79.3442 43.5989C79.3442 38.7014 83.1753 34.7467 88.0734 34.7467C90.7179 34.7467 92.645 35.7905 94.0753 37.1241L96.43 34.7697C94.4432 32.8659 91.7987 31.4081 88.0918 31.4081C81.3724 31.4081 75.7339 36.8804 75.7339 43.5805C75.7339 50.299 81.3678 55.7528 88.0918 55.7528C91.7205 55.7528 94.4432 54.5664 96.5956 52.3315C98.7894 50.138 99.4839 47.0432 99.4839 44.5462C99.4839 43.769 99.4241 43.07 99.2999 42.4768H88.0504C88.055 42.4722 88.055 42.5136 88.055 42.5136ZM171.617 45.098C170.959 43.3368 168.972 40.0994 164.898 40.0994C160.859 40.0994 157.502 43.277 157.502 47.9445C157.502 52.3499 160.823 55.7896 165.288 55.7896C168.876 55.7896 170.964 53.5961 171.824 52.3085L169.161 50.5243C168.278 51.8349 167.05 52.6948 165.307 52.6948C163.545 52.6948 162.313 51.8946 161.494 50.3173L171.985 45.9717C171.985 45.9763 171.617 45.098 171.617 45.098ZM160.919 47.7192C160.836 44.6887 163.274 43.1482 165.017 43.1482C166.392 43.1482 167.537 43.8242 167.928 44.8083L160.919 47.7192ZM152.397 55.3206H155.842V32.2726H152.397V55.3206ZM146.74 41.8606H146.616C145.839 40.9363 144.362 40.0994 142.477 40.0994C138.563 40.0994 134.957 43.5437 134.957 47.9675C134.957 52.3729 138.544 55.7758 142.477 55.7758C144.339 55.7758 145.839 54.9343 146.616 53.9916H146.74V55.1182C146.74 58.1119 145.14 59.726 142.559 59.726C140.448 59.726 139.138 58.2085 138.604 56.9393L135.61 58.1901C136.47 60.2594 138.765 62.8208 142.555 62.8208C146.593 62.8208 150.015 60.4434 150.015 54.6446V40.5684H146.759V41.8606C146.763 41.8606 146.74 41.8606 146.74 41.8606ZM142.785 52.6994C140.407 52.6994 138.42 50.7128 138.42 47.9675C138.42 45.1992 140.407 43.1942 142.785 43.1942C145.14 43.1942 146.965 45.2222 146.965 47.9675C146.988 50.7128 145.144 52.6994 142.785 52.6994ZM187.746 32.2726H179.509V55.3206H182.954V46.5925H187.751C191.563 46.5925 195.312 43.8288 195.312 39.4418C195.312 35.0548 191.577 32.2726 187.746 32.2726ZM187.847 43.3735H182.949V35.464H187.847C190.427 35.464 191.885 37.5932 191.885 39.4188C191.885 41.226 190.409 43.3735 187.847 43.3735ZM209.118 40.0764C206.616 40.0764 204.036 41.1846 202.969 43.5989L206.023 44.8681C206.681 43.5989 207.886 43.1666 209.16 43.1666C210.944 43.1666 212.747 44.2335 212.788 46.1373V46.381C212.172 46.0315 210.82 45.4981 209.201 45.4981C205.904 45.4981 202.56 47.3007 202.56 50.6806C202.56 53.7755 205.264 55.762 208.277 55.762C210.59 55.762 211.864 54.7182 212.66 53.5087H212.784V55.293H216.104V46.4638C216.104 42.3527 213.051 40.0764 209.118 40.0764ZM208.686 52.6994C207.559 52.6994 205.982 52.1476 205.982 50.7312C205.982 48.947 207.95 48.271 209.629 48.271C211.147 48.271 211.864 48.5975 212.765 49.0481C212.517 51.1175 210.769 52.681 208.686 52.6994ZM228.219 40.5684L224.263 50.5657H224.139L220.041 40.5684H216.334L222.483 54.5434L218.979 62.3104H222.566L232.027 40.5684H228.219ZM197.211 55.3206H200.656V32.2726H197.211V55.3206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.243 13.8922C18.7095 14.467 18.4014 15.3453 18.4014 16.4949V57.2703C18.4014 58.4199 18.7095 59.2983 19.2614 59.8501L19.404 59.9742L42.2525 37.1286V36.6182L19.3856 13.768L19.243 13.8922Z",
    fill: "url(#paint0_linear_1_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8545 44.7669L42.2336 37.1471V36.6136L49.8545 28.9939L50.02 29.095L59.0344 34.2178C61.6145 35.6709 61.6145 38.0714 59.0344 39.5429L50.02 44.6657L49.8545 44.7669Z",
    fill: "url(#paint1_linear_1_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0204 44.6657L42.234 36.8804L19.2429 59.8685C20.0846 60.7698 21.4965 60.871 23.074 59.9927L50.0204 44.6657Z",
    fill: "url(#paint2_linear_1_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0204 29.095L23.074 13.7911C21.4965 12.8897 20.08 13.0139 19.2429 13.9152L42.234 36.8804L50.0204 29.095Z",
    fill: "url(#paint3_linear_1_1279)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.8546 44.5003L23.0921 59.703C21.5974 60.563 20.2636 60.5032 19.4036 59.7214L19.261 59.864L19.4036 59.9881C20.2636 60.7653 21.5974 60.8297 23.0921 59.9697L50.0386 44.6658L49.8546 44.5003Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    opacity: 0.12,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.0347 39.2762L49.8318 44.5002L49.9974 44.6657L59.0117 39.5429C60.304 38.8072 60.9387 37.8415 60.9387 36.8804C60.8605 37.7633 60.2028 38.6002 59.0347 39.2762Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0741 14.0578L59.0348 34.4846C60.203 35.1422 60.8606 36.0021 60.9618 36.8804C60.9618 35.9193 60.3271 34.9536 59.0348 34.2179L23.0741 13.7911C20.494 12.315 18.4014 13.5474 18.4014 16.495V16.7618C18.4014 13.8095 20.494 12.6001 23.0741 14.0578Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1279",
    x1: 40.203,
    y1: 16.055,
    x2: 3.60426,
    y2: 25.8081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.00657,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1279",
    x1: 62.3991,
    y1: 36.8804,
    x2: 17.7737,
    y2: 36.8804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_1279",
    x1: 45.7865,
    y1: 41.1167,
    x2: 16.4102,
    y2: 90.5657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_1279",
    x1: 13.4535,
    y1: 0.329695,
    x2: 26.5594,
    y2: 22.4144,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1279"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 73.7607,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogbadge);
export default __webpack_public_path__ + "static/media/googbadge.ebcf6ea7f51cf532f32ab859db284d36.svg";
export { ForwardRef as ReactComponent };